export default __webpack_public_path__ + "static/media/teambg.813c8da2.jpg";